/**
 * 收支项明细打印配置
 * 参照 salesRankingConfig.js，字段与模板 BILL_CONFIGS.ITEM_DETAIL 绑定
 */

import { getLoginName } from '@/utils/util'

export const BILL_TYPE = 'ITEM_DETAIL'
export const REPORT_TITLE = '收支项明细'

// 表格列定义
export const defColumns = [
  {
    dataIndex: 'rowIndex', width: 40, align: 'center',
    customRender: function (t, r, index) {
      return (t !== '合计') ? (parseInt(index) + 1) : t
    }
  },
  { title: '单据编号', dataIndex: 'billNo', width: 140 },
  { title: '往来单位', dataIndex: 'organName', width: 120, ellipsis: true },
  { title: '财务人员', dataIndex: 'handsPersonName', width: 100, ellipsis: true },
  { title: '操作员', dataIndex: 'userName', width: 100, ellipsis: true },
  { title: '账户信息', dataIndex: 'accountName', width: 120, ellipsis: true },
  { title: '单据类别', dataIndex: 'type', width: 80, ellipsis: true },
  { title: '收支项目', dataIndex: 'inOutItemName', width: 120, ellipsis: true },
  { title: '收入', dataIndex: 'itemInAmount', width: 100, align: 'right' },
  { title: '支出', dataIndex: 'itemOutAmount', width: 100, align: 'right' },
  { title: '单据日期', dataIndex: 'billTimeStr', width: 110 },
  { title: '备注', dataIndex: 'remark', width: 150, ellipsis: true }
]

// 打印数据构建 - 将列表数据 + 查询条件映射为打印字段
export function buildPrintData(dataSource, queryParam, userInfo, companyInfo) {
  // 前端计算合计：从 dataSource 末尾的"合计"行提取（tableAddTotalRow 已追加）
  const totalRow = (dataSource || []).find(item => item.rowIndex === '合计')
  const totalIncome = totalRow ? Number(totalRow.itemInAmount || 0) : 0
  const totalExpense = totalRow ? Number(totalRow.itemOutAmount || 0) : 0

  const rows = (dataSource || [])
    .filter(item => item.rowIndex !== '合计')
    .map((item, idx) => ({
      rowIndex: idx + 1,
      billNo: item.billNo || '',
      organName: item.organName || '',
      handsPersonName: item.handsPersonName || '',
      userName: item.userName || '',
      accountName: item.accountName || '',
      type: item.type || '',
      inOutItemName: item.inOutItemName || '',
      itemInAmount: item.itemInAmount || 0,
      itemOutAmount: item.itemOutAmount || 0,
      billTimeStr: item.billTimeStr || '',
      remark: item.remark || ''
    }))

  // 追加合计行到表格末尾
  if (totalRow) {
    rows.push({
      rowIndex: '合计',
      billNo: '',
      organName: '',
      handsPersonName: '',
      userName: '',
      accountName: '',
      type: '',
      inOutItemName: '',
      itemInAmount: Number(totalRow.itemInAmount || 0),
      itemOutAmount: Number(totalRow.itemOutAmount || 0),
      billTimeStr: '',
      remark: ''
    })
  }

  return {
    // 单据主体 — 字段名与模板 BILL_CONFIGS.ITEM_DETAIL headerGroup 绑定
    reportTitle: REPORT_TITLE,
    reportDate: new Date().toLocaleDateString(),
    billNo: (queryParam && queryParam.bill_no) || '',
    organName: (queryParam && queryParam.organName) || '',
    billCategory: (queryParam && queryParam.bill_category) || '',
    dateRange: (queryParam && queryParam.beginTime && queryParam.endTime)
      ? queryParam.beginTime + ' ~ ' + queryParam.endTime : '',
    creatorName: getLoginName(),
    totalIncome: totalIncome,
    totalExpense: totalExpense,
    // 单据明细 — 字段名 table 与模板表格元素 field: "table" 绑定
    table: rows,
    // 公司信息 / 其它信息
    companyName: (companyInfo && companyInfo.companyName) || '',
    companyAddress: (companyInfo && companyInfo.companyAddress) || '',
    companyTel: (companyInfo && companyInfo.companyTel) || '',
    companyFax: (companyInfo && companyInfo.companyFax) || ''
  }
}